import React from "react";
import { ThreeDots } from "react-loader-spinner";

import { systemGreenColor, LOADING_SPINNER_SIZE } from "../../../constants";

/**
 * Shared ThreeDots loading indicator used across inbox sidebar panels.
 */
const LoadingSpinner = ({
  width = LOADING_SPINNER_SIZE,
  height = LOADING_SPINNER_SIZE,
  color = systemGreenColor,
  className = "d-flex justify-content-center",
}) => {
  return (
    <span className={className}>
      <ThreeDots
        width={width}
        height={height}
        color={color}
        ariaLabel="loading-indicator"
      />
    </span>
  );
};

export default LoadingSpinner;
